export const company = {
  name: "株式会社DAISAN",
  nameEn: "DAISAN Co., Ltd.",
  representative: "山田 友信",
  founded: "2024年1月",
  capital: "50万円",
  employees: "6名（2026年8月現在）",
  address: "福岡市東区松崎4丁目20-26-1",
  phone: "092-984-5214",
  email: "info@daisan-fukuoka.co.jp",
  hours: "平日 9:00 - 18:00（土日祝はメールにて受付）",
};

export const philosophy = [
  {
    icon: "ri-heart-3-line",
    title: "誠実であること",
    text: "作業品質・料金・報告、すべてに透明性を。オーナー様の資産をお預かりしているという意識を全員で共有します。",
  },
  {
    icon: "ri-time-line",
    title: "速さは品質の一部",
    text: "見積回答は24時間以内、緊急時は最短即日対応。判断が速いことが、機会損失を防ぐ最良のコスト削減だと考えます。",
  },
  {
    icon: "ri-seedling-line",
    title: "地域と長く続く関係",
    text: "私たちの土台は地元。目の届く範囲で、責任ある仕事を、長く続けていく。派手ではないけれど、確かな一社でありたい。",
  },
];

export const timeline = [
  { year: "2005", event: "代表 山田、福岡県大手清掃会社に入社。マンション管理清掃を担当。" },
  { year: "2018", event: "自身も不動産オーナーとなり、清掃業者選定の課題を実感。" },
  { year: "2024", event: "株式会社DAISAN 設立。福岡市にて創業。" },
  { year: "2025", event: "管理物件数50棟を突破。サービスを本格展開。" },
  { year: "2026", event: "累計管理物件70棟超。久留米エリアへサービス拡大。" },
];